import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { ConfigProvider } from "antd";

import App from "@/App";
import { themeTokens } from "@/theme/tokens";

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: themeTokens.colors.primary[500],
        colorSuccess: themeTokens.colors.success[100],
        colorError: themeTokens.colors.danger[100],
        fontFamily: themeTokens.font.family.join(", "),
      },
    }}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ConfigProvider>,
);
